var normalizeSearch = function (text) {
    return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
};
// At most one wrong, missing, extra or swapped letter between the two ("mlich" → "milch").
var withinOneEdit = function (a, b) {
    if (Math.abs(a.length - b.length) > 1)
        return false;
    var i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
        if (a[i] === b[j]) {
            i++;
            j++;
            continue;
        }
        if (++edits > 1)
            return false;
        if (a.length === b.length && a[i] === b[j + 1] && a[i + 1] === b[j]) {
            i += 2;
            j += 2;
        }
        else if (a.length > b.length)
            i++;
        else if (b.length > a.length)
            j++;
        else {
            i++;
            j++;
        }
    }
    return edits + (a.length - i) + (b.length - j) <= 1;
};
/*
    One or two letters match the start of a word ("ei" → Eier, not Weizen); from three on anywhere in a term, so
    German compounds are found ("nuss" → Erdnüsse); from four on also with one typo.
*/
export var matchesSearch = function (terms, search) {
    var query = normalizeSearch(search.trim());
    if (!query)
        return true;
    return terms.some(function (term) {
        var text = normalizeSearch(term);
        var words = text.split(/[^a-z0-9]+/);
        if (query.length < 3)
            return words.some(function (word) { return word.startsWith(query); });
        if (text.includes(query))
            return true;
        if (query.length < 4)
            return false;
        return words.some(function (word) { return [query.length - 1, query.length, query.length + 1]
            .some(function (length) { return length <= word.length && withinOneEdit(query, word.slice(0, length)); }); });
    });
};
